export default {
  // Acciones y mensajes genericos del visor de recursos
  cancel: 'Cancel',
  confirm: 'Confirm',
  save: 'Save',
  resources: 'Resources',
  description: 'Description',
  default_description: 'Non description was provided.',
  confirm_delete: 'You are deleting a resource ¿Do you want to continue?',
  loading: 'Loading resources, please wait...',
  external_resource: 'This resource can\'t be showed inside the app, please click in the button "download" below to show it in the navigator.',

  // Formulario de creacion de un recurso
  create: {
    name: 'Name',
    description: 'Description',
    resource_type: 'Select resource type',
    resource_file: 'Select some file',
    assign_to: 'Assign to',
    non_resource_file: 'Non file was selected',
    resource_location: 'Select locations',
    resource_roles: 'Select roles'
  },

  // Opciones de tipo de recurso y alcance (radio buttons)
  radio: {
    img: 'Image',
    doc: 'Document',
    video: 'Video',
    all_usr: 'All users',
    locations: 'Locations',
    roles: 'Roles'
  },

  // Validaciones del formulario de creacion
  upload_by_role: {
    setting: 'In Resources, "Upload to all locations" only uploads to the locations where the user has a role.',
    checkbox_all: 'Upload to all locations',
    checkbox: 'Upload to all my locations',
    saved: 'The document was saved successfully.',
    updated: 'The document was updated in your subgroup locations successfully.',
    no_locations: 'You have no role in any location of this folder.'
  },
  validate: {
    file: 'No se ha seleccionado un archivo',
    name: 'No se ha introducido un nombre',
    description: 'No se ha introducido una descripción'
  }
}
